import * as consts from '../constants';
import initialState from './initialState';

export default function networkReducer(state = initialState.networkState, action) {
    switch (action.type) {
        case consts.ACTONS.LOAD_NETWORKS_SUCCESS:
            return action.pagingModel;
        case consts.ACTONS.LOAD_NETWORKS_FAILED:
            return initialState.networkState;
        default:
            return state;
    }
}
